import { createApp } from "vue";
import { createRouter, createWebHistory } from "vue-router";
import Vuex from "vuex";
import App from "./App.vue";
import Home from "./views/Home.vue";
import Login from "./views/Login.vue";
import Register from "./views/Register.vue";
import User from "./views/User.vue";
import AirportBrowser from "./views/AirportBrowser.vue";
import Profile from "./views/Profile.vue";
import Flights from "./views/Flights.vue";
import Airplanes from "./views/Airplanes.vue";
import AirplaneDetail from "./views/AirplaneDetail.vue";
import MassImport from "./views/MassImport.vue";
import FlightExport from "./views/FlightExport.vue";

import "vuetify/styles";
import { createVuetify } from "vuetify";
import * as components from "vuetify/components";
import * as directives from "vuetify/directives";

const store = new Vuex.Store({
	state: {
		token: null,
		user: null,
	},
	mutations: {
		setUser(state, user) {
			state.user = user;
		},
		setToken(state, token) {
			state.token = token;
		},
	},
	actions: {},
	getters: {
		isLoggedIn(state) {
			return !!state.token;
		},
		getToken(state) {
			return state.token;
		},
	},
});

const router = createRouter({
	routes: [
		{ name: "Home", path: "/", component: Home, meta: { needsAuth: true } },
		{ name: "Login", path: "/login", component: Login },
		{ name: "Register", path: "/register", component: Register },
		{ name: "User", path: "/user", component: User, meta: { needsAuth: true } },
		{
			name: "Airport Browser",
			path: "/airports",
			component: AirportBrowser,
			meta: { needsAuth: true },
		},
		{
			name: "Profile",
			path: "/profile",
			component: Profile,
			meta: { needsAuth: true },
		},
		{
			name: "Flights",
			path: "/flights",
			component: Flights,
			meta: { needsAuth: true },
		},
		{
			name: "Airplanes",
			path: "/planes",
			component: Airplanes,
			meta: { needsAuth: true },
		},
		{
			name: "Airplane Detail",
			path: "/planes/:id",
			props: true,
			component: AirplaneDetail,
			meta: { needsAuth: true },
		},
		{
			name: "Import",
			path: "/flights/import",
			component: MassImport,
			meta: { needsAuth: true },
		},
		{
			name: "Export",
			path: "/flights/export",
			component: FlightExport,
			meta: { needsAuth: true },
		},
	],
	history: createWebHistory(),
});

router.beforeEach((to, from) => {
	if (to.meta.needsAuth) {
		if (!store.getters.isLoggedIn) {
			return { name: "Login" };
		}
	}
	if (to.fullPath == "/login" && store.getters.isLoggedIn) {
		return { name: "Home" };
	}
});

const vuetify = createVuetify({
	components,
	directives,
});

createApp(App).use(router).use(store).use(vuetify).mount("#app");
